export default "__VITE_ASSET__1f53f29a__"